import React from 'react'

import { copyToClipboard, getHeadingId } from '../../lib/helpers'
import { headingLink } from '../typography.module.css'

const HeadingLink = ({ data }) => {
  const handleOnClick = event => {
    setTimeout(() => copyToClipboard(window.location.href), 0)
  }

  // TODO When one or more headings already exist with the same ID, increment it
  // i.e. heading-id, heading-id1, heading-id2,
  return (
    <a
      onClick={handleOnClick}
      className={headingLink}
      href={`#${getHeadingId(data)}`}
    >#
    </a>
  )
}

export default HeadingLink
